// Permissões granulares no painel: o que o usuário logado pode fazer (catálogo em suporte-app/app/permissoes.py).
// A tela só mostra/esconde — quem bloqueia de verdade é o servidor.
// REGRA DO PROJETO: botão/tela de função nova usa usePermissao("chave") (ver CLAUDE.md).
import { useEffect, useState } from "react";

import suporteApi from "./api";

let atual = null; // Set com as chaves
let tokenDoCache = null;
let promessa = null;
const ouvintes = new Set();

const tokenAtual = () => {
  try {
    return localStorage.getItem("token");
  } catch {
    return null;
  }
};

export const carregarPermissoes = (forcar = false) => {
  const token = tokenAtual();
  if (token !== tokenDoCache) { // trocou de usuário (login/logout) sem recarregar a página
    tokenDoCache = token;
    atual = null;
    promessa = null;
  }
  if (!promessa || forcar) {
    promessa = suporteApi.get("/api/permissoes/eu")
      .then((r) => {
        atual = new Set(r.data.permissoes || []);
        ouvintes.forEach((f) => f(atual));
        return atual;
      })
      .catch(() => {
        promessa = null;
        return atual;
      });
  }
  return promessa;
};

export const usePermissoes = () => {
  const [p, setP] = useState(atual);
  useEffect(() => {
    ouvintes.add(setP);
    carregarPermissoes().then((x) => x && setP(x));
    return () => ouvintes.delete(setP);
  }, []);
  return p;
};

export const tem = (permissoes, chave) => !!permissoes && permissoes.has(chave);

export const usePermissao = (chave) => tem(usePermissoes(), chave);
